import React from 'react';
import { Link } from 'react-router-dom';
import { Plus, MessageSquare } from 'lucide-react';

// Recent chat activity, rendered as compact editorial rows.
const RecentActivity = ({ chats = [], loading = false, onStartChat }) => {
  const formatDate = (s) => {
    const d = new Date(s);
    const days = Math.floor((Date.now() - d.getTime()) / 86_400_000);
    if (days === 0) return 'Today';
    if (days === 1) return 'Yesterday';
    if (days < 7) return `${days}d ago`;
    return d.toLocaleDateString();
  };

  return (
    <section className="h-full flex flex-col rounded-2xl border border-gray-200/80 dark:border-gray-800 bg-white dark:bg-gray-900/40 overflow-hidden">
      <header className="shrink-0 flex items-center justify-between px-5 py-3.5 border-b border-gray-100 dark:border-gray-800">
        <span className="text-[11px] font-semibold uppercase tracking-[0.14em] text-gray-400 dark:text-gray-500">
          Recent Activity
        </span>
        {chats.length > 0 && (
          <Link to="/dashboard/chats" className="text-xs font-medium text-blue-600 dark:text-blue-400 hover:text-blue-700 dark:hover:text-blue-300">
            View all
          </Link>
        )}
      </header>

      <div className="flex-1 min-h-0 overflow-y-auto">
      {loading ? (
        <div className="p-5 space-y-3">
          {[1, 2, 3].map((i) => (
            <div key={i} className="animate-pulse h-12 bg-gray-100 dark:bg-gray-800/60 rounded-lg" />
          ))}
        </div>
      ) : chats.length === 0 ? (
        <div className="px-5 py-10 text-center">
          <MessageSquare size={22} className="mx-auto text-gray-300 dark:text-gray-700 mb-3" />
          <p className="text-sm text-gray-500 dark:text-gray-400 font-rasa mb-4">No conversations yet.</p>
          <button
            onClick={onStartChat}
            className="inline-flex items-center gap-1.5 px-4 py-2 rounded-lg bg-blue-600 text-white text-sm font-medium hover:bg-blue-700 transition-colors"
          >
            <Plus size={15} /> Start your first conversation
          </button>
        </div>
      ) : (
        <ul className="divide-y divide-gray-100 dark:divide-gray-800">
          {chats.map((chat) => (
            <li key={chat.id}>
              <Link
                to={`/dashboard/unified-chat?chat_id=${chat.id}`}
                className="flex items-start justify-between gap-4 px-5 py-3.5 hover:bg-blue-50/40 dark:hover:bg-blue-900/10 transition-colors"
              >
                <div className="min-w-0">
                  <h4 className="text-[14px] font-medium font-rasa text-gray-900 dark:text-white truncate">
                    {chat.title || 'Untitled conversation'}
                  </h4>
                  {chat.preview && (
                    <p className="text-[12.5px] text-gray-500 dark:text-gray-400 line-clamp-1 mt-0.5">
                      {chat.preview}
                    </p>
                  )}
                </div>
                <div className="shrink-0 text-right pt-0.5">
                  <span className="block text-[11px] text-gray-400 dark:text-gray-500">
                    {formatDate(chat.updated_at)}
                  </span>
                  {typeof chat.message_count === 'number' && (
                    <span className="block text-[10.5px] text-gray-400 dark:text-gray-500 mt-0.5">
                      {chat.message_count} messages
                    </span>
                  )}
                </div>
              </Link>
            </li>
          ))}
        </ul>
      )}
      </div>
    </section>
  );
};

export default RecentActivity;
